<template lang="pug">

  .lesson-block__content.lesson-test.-edit-

    .lesson-test-slider
      component(
        v-for="(slide, idx) in slides" :key="slide.frontDeleteKey"
        :is="slide.component"
        v-show="idx === currentSlideIdx"
        :propData="slide.data"
        :idx="idx"
        :questionSlidesLength="questionSlidesLength"
        :currentSlideIdx="currentSlideIdx"
        :navText.sync="navText"
        @goToSlide="goToSlide"
        @updateDescription="updateDescription"
        @updateQuestion="updateQuestion($event, idx)"
        @deleteQuestion="deleteQuestion(idx)"
        @addQuestion="addQuestion(idx)"
        @updateIntervalsToDelete="updateIntervalsToDelete"
        @updateResults="updateResults"
      )

    Navigation(
      :slides="slides"
      :currentSlideIdx="currentSlideIdx"
      :isLoading="isLoading"
      @goToSlide="goToSlide"
      @saveBlock="saveBlockWithGet"
    )

</template>

<script>
import _ from 'lodash';
import Description from './Description';
import Navigation from './Navigation';
import Question from './Question/index';
import Results from './Results';

export default {
  components: {
    Description,
    Navigation,
    Question,
    Results
  },
  props: {
    content: {},
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    currentSlideIdx: 0,
    navText: '',
    slides: [],
    frontDeleteKey: 0,
    slidesToDelete: [],
    intervalsToDelete: [],
    emptyQuestion: {
      id: '',
      text: 'Новый вопрос',
      isMultipleAnswers: false,
      isDeleted: false,
      position: 0,
      img: {},
      answers: [
        {
          id: '',
          text: 'Ответ 1',
          isCorrect: true,
          isDeleted: false,
          position: 0,
          points: 0,
          answerDeleteId: 0
        }
      ]
    },
    contentToUpdate: {
      questions: [],
      results: []
    }
  }),
  computed: {
    questionSlidesLength() {
      const slidesArr = _.cloneDeep(this.slides).filter(item => item.component === 'Question');
      return slidesArr.length;
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.contentToUpdate = _.cloneDeep(this.content);
      // массив вопросов потом вставляется после первого жлемента
      this.slides = [];
      let questionsArr = [];
      Object.entries(this.content).forEach(item => {
        switch (item[0]) {
          case 'preview':
            this.frontDeleteKey++;
            this.slides.push({
              component: 'Description',
              frontDeleteKey: this.frontDeleteKey,
              data: {
                ...item[1]
              }
            });
            return;
          case 'results':
            this.frontDeleteKey++;
            this.slides.push({
              component: 'Results',
              frontDeleteKey: this.frontDeleteKey,
              data: [...item[1]]
            });
            return;
          case 'questions':
            questionsArr = item[1].map(data => {
              this.frontDeleteKey++;
              return {
                component: 'Question',
                frontDeleteKey: this.frontDeleteKey,
                data
              };
            });
            return;
          default:
            return;
        }
      });
      if (questionsArr.length) {
        this.slides.splice(1, 0, ...questionsArr);
      }
    },
    deleteQuestion(idx) {
      // -1 пушто начинается с дескрипшена
      if (this.questionSlidesLength > 1) {
        this.slides[idx].data.isDeleted = true;
        if (this.slides[idx].data.id) {
          this.slidesToDelete.push(this.slides[idx]);
        }

        this.contentToUpdate.questions.splice(idx - 1, 1);

        this.slides = this.slides.filter(s => !s.data.isDeleted);
        this.slides = [...this.slides];
        this.currentSlideIdx = idx - 1;
      }
    },
    goToSlide(idx) {
      if (idx !== -1 && idx !== this.slides.length) {
        this.currentSlideIdx = idx;
      }
    },
    addQuestion(idx) {
      this.frontDeleteKey++;
      // Если добавление с первого экрана
      if (idx === 0) {
        this.slides.splice(this.slides.length - 1, 0, {
          component: 'Question',
          frontDeleteKey: this.frontDeleteKey,
          data: { ...this.emptyQuestion }
        });

        this.contentToUpdate.questions.push({ ...this.emptyQuestion });

        this.currentSlideIdx = this.slides.length - 2;
      } else {
        // Если добавление с экрана вопроса
        this.slides.splice(idx + 1, 0, {
          component: 'Question',
          frontDeleteKey: this.frontDeleteKey,
          data: { ...this.emptyQuestion }
        });
        this.contentToUpdate.questions.splice(idx, 0, {
          ...this.emptyQuestion
        });

        this.currentSlideIdx = idx + 1;
      }
    },
    updateDescription(preview) {
      this.contentToUpdate.preview = _.cloneDeep(preview);
    },
    updateQuestion(question, idx) {
      // -1 пушто начинается с дескрипшена
      this.contentToUpdate.questions[idx - 1] = _.cloneDeep(question);
      this.contentToUpdate.questions = [...this.contentToUpdate.questions];
    },
    saveBlockWithGet() {
      // Если есть вопросы на удаление - добавляем перед отправкой
      if (this.slidesToDelete.length > 0) {
        this.contentToUpdate.questions.push(...this.slidesToDelete.map(item => item.data));
      }

      // Проставляем позишены
      let qPos = 0;
      this.contentToUpdate.questions = this.contentToUpdate.questions.map(q => {
        q.position = qPos;
        qPos++;
        return q;
      });
      // Если есть интервалы на удаление - добавляем перед отправкой
      if (this.intervalsToDelete.length > 0) {
        this.intervalsToDelete.forEach(interval => {
          this.contentToUpdate.results.push(interval);
        });
      }
      // Проставляем позишены
      if (this.contentToUpdate.results && this.contentToUpdate.results.length > 0) {
        let rPos = 0;
        this.contentToUpdate.results = this.contentToUpdate.results.map(interval => {
          interval.position = rPos;
          rPos++;
          return interval;
        });
      }

      this.$emit('updateContent', this.contentToUpdate);
      this.$emit('saveBlockWithGet');
    },
    updateIntervalsToDelete(intervalsToDelete) {
      this.intervalsToDelete = intervalsToDelete;
    },
    updateResults(results) {
      this.contentToUpdate.results = _.cloneDeep(results);
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-block__content {
  &::v-deep .lesson-test-slider {
    margin-top: 32px;
  }
}
</style>
